import { PropsWithChildren, useCallback, useState } from 'react';

import ReCAPTCHAv2 from '~/components/ReCAPTCHAv2';

import styles from './CaptchaOverlay.module.scss';

type TCaptchaOverlayProps = {
  onChange: (key: string) => unknown;
  dismissCaptcha: () => void;
  showCaptcha: boolean;
};

export function CaptchaOverlay({
  children,
  showCaptcha,
  dismissCaptcha,
  onChange,
}: PropsWithChildren<TCaptchaOverlayProps>): JSX.Element {
  const [isCaptchaProcessing, setCaptchaProcessing] = useState(false);

  const onCaptchaChange = useCallback(
    (key: string) => {
      setCaptchaProcessing(true);
      Promise.resolve(onChange(key)).finally(() => {
        setCaptchaProcessing(false);
      });
    },
    [onChange],
  );

  return (
    <>
      {children}
      {showCaptcha && (
        <div
          className={styles.overlay}
          onClick={({ target, currentTarget }) => {
            if (!currentTarget.isEqualNode(target as Node)) {
              return;
            }
            if (!isCaptchaProcessing) {
              dismissCaptcha();
            }
          }}
          role={isCaptchaProcessing ? 'presentation' : 'button'}
        >
          <ReCAPTCHAv2
            siteKey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
            className={styles.captcha}
            onChange={onCaptchaChange}
          />
        </div>
      )}
    </>
  );
}
